import { APIClient } from '@frontend/api-utils';

export class SettingJsonClient extends APIClient {
    public static readonly endpoint = '/setting-api/json/v1';

    public static async fetchSettingsJson(accountId: string) {
        const response = await this.fetch(`${this.endpoint}/accounts/${accountId}/settings`);
        return await this.handleBlobResponse(response);
    }

    public static async postSettingsJson(accountId: string, file: File) {
        const formData = new FormData();
        formData.append('file', file);

        const response = await this.post(`${this.endpoint}/accounts/${accountId}/settings`, formData);
        return await this.handleBlobResponse(response);
    }
}
